import { render, staticRenderFns } from "./StagingEditorSectionCard.vue?vue&type=template&id=a8ac3264"
import script from "./StagingEditorSectionCard.vue?vue&type=script&lang=ts"
export * from "./StagingEditorSectionCard.vue?vue&type=script&lang=ts"
import style0 from "./StagingEditorSectionCard.vue?vue&type=style&index=0&id=a8ac3264&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports